module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "upload-qiniu"
  }, [_c('div', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.pId
    }
  }, [_c('div', {
    staticClass: "btn",
    attrs: {
      "id": _vm.bId
    }
  }, [_vm._t("upload")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3de3b94"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upload/Upload.vue
// module id = 540
// module chunks = 1